import { useEffect } from 'react';

import { useUIStore } from '@/stores/ui-store';

/**
 * Syncs the theme state from the UI store to the document element.
 * Applies or removes the 'dark' class on <html> so Tailwind's dark: variants activate.
 * Also listens for OS-level preference changes when theme is set to 'system'.
 */
export function useThemeSync() {
  const { theme } = useUIStore();

  useEffect(() => {
    const root = document.documentElement;

    function applyTheme(resolvedTheme: 'light' | 'dark') {
      if (resolvedTheme === 'dark') {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
    }

    if (theme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      applyTheme(mediaQuery.matches ? 'dark' : 'light');

      const handler = (e: MediaQueryListEvent) => {
        applyTheme(e.matches ? 'dark' : 'light');
      };
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
    }

    applyTheme(theme);
  }, [theme]);
}
